import { ToastPosition } from "react-bootstrap/esm/ToastContainer"

export enum ToastEnum {
  WARNING = 'warning',
  DANGER = 'danger',
  INFO = 'infor',
  ERROR = 'error',
  SUCCESS = 'success'
}

export interface IToast {
  type?: ToastEnum
  title?: string
  position: ToastPosition
  body?: string
  isShow: boolean
  handleClose?(): void
}